import { Stack, Typography, useTheme } from '@mui/material';
import { GetStripeSubscriptionDetailsResponse } from 'src/graphql/entities/stripe-subscription-details';
import { SubscriptionDetailsSummary } from './subscription-details-summary';
import { SubscriptionScheduleTimeline } from './subscription-schedule-timeline';

export const SubscriptionDetailsPanel = ({
  subscriptionDetails,
}: {
  subscriptionDetails: GetStripeSubscriptionDetailsResponse | undefined;
}) => {
  const theme = useTheme();

  if (!subscriptionDetails) return null;

  const hasSchedulePhases = Boolean(subscriptionDetails.schedule?.phases.length);

  return (
    <Stack mt={theme.spacing(2)}>
      <Typography variant="subtitle2" py={1} mb={theme.spacing(1)} fontSize="0.75rem">
        Subscription Details
      </Typography>

      <SubscriptionDetailsSummary subscriptionDetails={subscriptionDetails} />

      <Typography variant="subtitle2" paddingTop={2} mb={theme.spacing(1)} fontSize="0.75rem">
        Subscription Schedule
      </Typography>

      {hasSchedulePhases || subscriptionDetails.paused ? (
        <SubscriptionScheduleTimeline
          schedule={subscriptionDetails.schedule}
          paused={subscriptionDetails.paused}
          resumesAt={subscriptionDetails.resumesAt}
        />
      ) : (
        <Typography variant="body2" color="text.secondary" pb={2}>
          No schedule
        </Typography>
      )}
    </Stack>
  );
};
